import { type AuthFieldError } from './types';

/**
 * Helper to convert AuthFieldError to string for display in form inputs
 */
export function getFieldErrorMessage(error: AuthFieldError | string | undefined): string | undefined {
  if (!error) return undefined;
  if (typeof error === 'string') return error;
  return error.message;
}
